import { TypeIdSchema } from '@unipile/db';
import {
  TSchema,
  Type,
  type TIntersect,
  type TLiteral,
  type TObject,
  type TString,
  type TTemplateLiteral,
} from '@sinclair/typebox';

export const BaseMethodParamsSchema = Type.Object({
  account_id: TypeIdSchema('account', {
    description: 'ID of the Account (acc_xxx) to call the method on behalf of.',
  }),
});

// export function methodPathParams<T extends TProperties>(
//   params: TObject<T>
// ): TIntersect<
//   [
//     TObject<T>,
//     TObject<{
//       account_id: TTemplateLiteral<[TLiteral<'acc'>, TLiteral<'_'>, TString]>;
//     }>
//   ]
// > {
//   return Type.Intersect([params, BaseMethodParamsSchema]);
// }

export function methodPathParams<T extends TSchema>(
  params: T,
): TIntersect<
  [
    T,
    TObject<{
      account_id: TTemplateLiteral<[TLiteral<'acc'>, TLiteral<'_'>, TString]>;
    }>,
  ]
> {
  return Type.Intersect([params, BaseMethodParamsSchema]);
}
